<div class="filter-popup" [ngStyle]="popupPosition">
  <label class="d-block"><strong>Show items with value that:</strong></label>

  @if(kind == 'text'){
    <mat-form-field appearance="fill" class="d-block">
      <mat-select [(ngModel)]="filterCondition">
        <mat-option value="equals">Is equal to</mat-option>
        <mat-option value="notequals">Is not equal to</mat-option>
        <mat-option value="startswith">Starts with</mat-option>
        <mat-option value="contains">Contains</mat-option>
        <mat-option value="doesnotcontain">Does not contain</mat-option>
        <mat-option value="endwith">Ends with</mat-option>
        <mat-option value="isnull">Is null</mat-option>
        <mat-option value="isnotnull">Is not null</mat-option>
        <mat-option value="isempty">Is empty</mat-option>
        <mat-option value="isnotempty">Is not empty</mat-option>
      </mat-select>
    </mat-form-field>
  }@else if(kind == 'date'){
    <mat-form-field appearance="fill" class="d-block">
      <mat-select [(ngModel)]="filterCondition">
        <mat-option value="date_equals">Is equal to</mat-option>
        <mat-option value="date_notequals">Is not equal to</mat-option>
        <mat-option value="date_gte">Is after or equal to</mat-option>
        <mat-option value="date_gt">Is after</mat-option>
        <mat-option value="date_lte">Is before or equal to</mat-option>
        <mat-option value="date_lt">Is before</mat-option>
        <mat-option value="date_isnull">Is null</mat-option>
        <mat-option value="date_isnotnull">Is not null</mat-option>
      </mat-select>
    </mat-form-field>
  }@else if(kind == 'number'){
    <mat-form-field appearance="fill" class="d-block">
      <mat-select [(ngModel)]="filterCondition">
        <mat-option value="number_equals">Is equal to</mat-option>
        <mat-option value="number_notequals">Is not equal to</mat-option>
        <mat-option value="number_gte">Is greater than or equal to</mat-option>
        <mat-option value="number_gt">Is greater than</mat-option>
        <mat-option value="number_lte">Is less than or equal to</mat-option>
        <mat-option value="number_lt">Is less than</mat-option>
        <mat-option value="number_isnull">Is null</mat-option>
        <mat-option value="number_isnotnull">Is not null</mat-option>
      </mat-select>
    </mat-form-field>
  }

  @if(kind === 'text'){
      <mat-form-field appearance="fill" class="d-block">
        <input matInput [(ngModel)]="filterValue" placeholder="Enter value" />
      </mat-form-field>
  }@else if(kind === 'date'){
    <mat-form-field appearance="fill" class="d-block">
      <input
        matInput
        [matDatepicker]="picker"
        [(ngModel)]="filterValue"
        placeholder="Choose a date"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  }@else if(kind === 'boolean'){
    <mat-radio-group [(ngModel)]="filterValue" class="d-block" layout="row">
      <mat-radio-button value="true" class="mr-3">Is true</mat-radio-button>
      <mat-radio-button value="false">Is false</mat-radio-button>
    </mat-radio-group>
  }@else if(kind === 'number'){
    <mat-form-field appearance="fill" class="d-block">
      <input
        matInput
        type="number"
        [(ngModel)]="filterValue"
        placeholder="Enter number"
      />
    </mat-form-field>
  }@else{
    <ng-template>
      <h6>Still not supported</h6>
    </ng-template>
  }

  <div class="filter-actions d-block">
    <button mat-raised-button (click)="applyFilter()" class="fltBtn">Filter</button>
    <button mat-button (click)="clearFilter()" class="clrBtn">Clear</button>
  </div>
</div>
